import {
  AppContext,
  BackgroundIcon,
  DateTimeFormatter,
  NewTask,
  toast,
  getTranslatedText,
  COMMON_CONSTANTS
} from '@nile/components';
import { TicketClient, UPDATE_TASK, DELETE_TASK } from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import { Receiver, Sender } from '@nile/mangifera/src/Pebbles/chat';
import { GET_PROJECT } from '@nile/projects/src/Graphql';
import { constructTaskObject } from '@nile/projects/src/Utils';
import { Avatar, TextStyle } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import React, { useContext, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import styled from 'styled-components';
import { useCheckIsItProduct } from '@nile/components/src/Utils/helpers';
import WorklogTask from '@nile/components/src/Containers/NewWorklog/WorklogTask.js';
const StyledNote = styled.div`
  background: ${(props) =>
    props.user ? '#e5fdff;' : 'var(--sops-coversation-bubble-bg)'};
  border-radius: 20px 20px;
  width: 75%;
  margin-left: 12px;
  padding: 10px 15px 15px 15px;
  opacity: 1;
  transition: opacity 200ms linear;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.102874);
  .message-content {
    margin-top: 10px;
    word-break: break-word;
  }
  .action > div:first-child {
    visibility: hidden;
  }

  &:hover {
    .action > div:first-child {
      visibility: visible;
      cursor: pointer;
    }
  }
  .ap {
    background-image: url(${envConfig.imageRoot}emojis.webp);
  }
`;

function TaskBubble(props) {
  const { message, intl } = props;
  const appContext = useContext(AppContext);
  const { user, company } = appContext;

  const [sheetActive, setSheetActive] = useState(false);

  const isItProduct = useCheckIsItProduct();

  const toggleSheetActive = () => {
    setSheetActive(!sheetActive);
  };

  const [currentTask, setCurrentTask] = useState(message?.data);
  const Tags = {
    sender: Sender,
    receiver: Receiver
  };

  const userType =
    message?.user?.userId === user?.userId ? 'sender' : 'receiver';
  const Tag = Tags[userType];

  const handleTaskUpdation = (id, task, cb) => {
    const taskObj = constructTaskObject(task);
    TicketClient.mutate({
      mutation: UPDATE_TASK,
      variables: { taskId: id, module: 'PROJECT', input: taskObj }
    })
      .then((res) => {
        if (res?.data?.updateTask) {
          setCurrentTask(res.data.updateTask);
          TicketClient.query({
            query: GET_PROJECT,
            variables: { projectId: message.project.projectId, isItProduct },
            fetchPolicy: 'network-only'
          }).then((resp) => {
            if (resp?.data?.getProject) {
              toast('success', 'Task updated successfully');
              message.setProject(resp.data.getProject);
              cb();
            }
          });
        }
      })
      .catch((err) => {});
  };

  const deleteTaskHandler = (id, toggleSheet) => {
    TicketClient.mutate({
      mutation: DELETE_TASK,
      variables: { taskId: id, module: 'PROJECT' }
    }).then((res) => {
      if (res?.data?.deleteTask) {
        toast(
          'success',
          getTranslatedText(intl, 'ticket.details.task.delete.success')
        );
        if (toggleSheet) {
          toggleSheetActive();
        }
      }
    });
  };

  return (
    <Tag className="fx bubbleContainer">
      <div className="avatar mr8">
        <Avatar
          size="small"
          initials={`${message?.user?.firstName?.[0]}${
            message?.user?.lastName?.[0] ? message?.user?.lastName?.[0] : ''
          }`}
          source={`${envConfig.imageRoot}svg/notification.svg`}
        />
      </div>
      <SwitchTransition>
        <CSSTransition
          key={message?.id}
          timeout={200}
          in
          appear
          classNames="bubbles"
          unmountOnExit
        >
          <StyledNote
            className="bubble"
            user={message.user && userType === 'sender'}
          >
            <div className="fx">
              <div className="fx2 fx actr f-12">
                <div className="mr8">
                  <SVGIcon name="Tasks" size="sm" />
                </div>
                <TextStyle variation="subdued">
                  <FormattedMessage id="project.details.convoBubble.task" />{' '}
                  &nbsp;
                  <TextStyle variation="strong">
                    {`${message?.status}`}
                  </TextStyle>
                  {message?.user && (
                    <>
                      &nbsp;
                      <TextStyle>{` by `}</TextStyle>
                      &nbsp;
                      <TextStyle variation="strong">
                        {`${message?.user?.firstName} ${message?.user?.lastName}`}
                      </TextStyle>
                    </>
                  )}
                </TextStyle>
              </div>
              <div
                className="fx2 fx jend f-12"
                title={
                  <DateTimeFormatter type="dateTime" date={message?.time} />
                }
                // title={dayjs(message?.time).format(
                //   `${company?.dateFormat ||
                //     'MMM DD YYYY'}, ${company?.timeFormat || 'hh:mm A'}`
                // )}
              >
                <TextStyle variation="subdued">
                  <DateTimeFormatter type="dateTime" date={message?.time} />
                  {/* {dayjs(message?.time).format(
                    `${company?.dateFormat ||
                      'MMM DD YYYY'}, ${company?.timeFormat || 'hh:mm A'}`
                  )} */}
                </TextStyle>
              </div>
            </div>
            <div className="fx mt10">
              <WorklogTask
                task={currentTask}
                workItem={currentTask?.workItem}
                hideTaskWorkItem
                hideIcon
              />
            </div>
          </StyledNote>
        </CSSTransition>
      </SwitchTransition>
    </Tag>
  );
}

export default injectIntl(TaskBubble);
